angular
  .module 'filters'
  .filter 'limitString', ($filter) ->
    (input, limit) ->
      return unless input && input.length
      result = $filter('limitTo')(input, limit)
      result = result + '...' if input.length > limit
      result
